const baseURL: string ="https://celltek-realestate.herokuapp.com";

export default baseURL;
